import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class SettlementValidations {


  constructor() { }


  public isVisibleRegisterData(model: any) {
    if (model.dto.registerNumberContractModificacion && model.dto.registrationDate) {
      return true;
    } else {
      return false;
    }
  }


}